<div class="stat-group">
  <article>{{ advert().streetNameAndHouseNumber }}</article>
  <article>{{ advert().direction }}</article>
  <article>{{ advert().postalCodeAndCity }}</article>
</div>

<div class="stat-group">
  <advert-rooms-label [advert]="advert()" />
  <view-unit-intranet [internalId]="advert().internalId" />
  <view-unit-acm [internalId]="advert().internalId" />
</div>

<div class="stat-group">
  <article>
    {{ advert().hasNoContactAssigned ? ('SHARED_COMPONENT.NO_CONTACT' | translate) : advert().contactDisplay }}
  </article>
  @if (advert().hasSubstituteContact) {
    <article>
      {{ advert().substituteContact.firstName }} {{ advert().substituteContact.lastName }}
    </article>
  }
</div>

<div class="stat-group">
  <article>{{ 'KEY_FACTS.availableFromDate' | translate }}</article>
  @if (advert().isAvailabeUponAgreement) {
    <article>{{ 'SHARED_COMPONENT.UPON_AGREEMENT' | translate }}</article>
  }
  @if (!advert().isAvailabeUponAgreement) {
    <article>
      {{
      advert().isAvailableFromNowOn
      ? ('KEY_FACTS.availableFromNowOnTeaser' | translate)
      : (advert().availabeFrom | convertDate)
      }}
    </article>
  }
</div>

<div class="stat-group">
  <article>{{ 'KEY_FACTS.cost' | translate }}</article>
  @if (advert().cost) {
    <article>
      <span> {{ advert().cost | numeral }} {{ advert().localization.currency }}</span>
      <span> | {{ advert().costPerSize | numeral }}</span>
      <span> {{ advert().localization.currency }}/{{ advert().areaSizeUnit }}</span>
    </article>
  }
  @if (!advert().cost) {
    <article>-</article>
  }
</div>
